const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20with%20dramatic%20golden%20hour%20lighting%2C%20abstract%20movie%20poster%20style%20with%20warm%20amber%20and%20deep%20shadow%20tones%2C%20artistic%20composition%20with%20film%20grain%20texture%2C%20elegant%20minimalist%20design%2C%20no%20text%20no%20people%2C%20sophisticated%20cinema%20aesthetic&width=800&height=500&seq=card-movie-01&orientation=landscape',
    tag: '热映推荐',
    title: '2026暑期档必看大片盘点',
    desc: '整理今夏最值得期待的电影清单，从科幻巨制到温情文艺，每一部都不容错过。',
    meta: '12部精选 · 持续更新',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20television%20drama%20atmosphere%20with%20warm%20indoor%20lighting%20and%20soft%20shadows%2C%20abstract%20composition%20suggesting%20storytelling%2C%20golden%20and%20amber%20tones%2C%20cinematic%20mood%2C%20minimalist%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-tv-02&orientation=landscape',
    tag: '剧集精选',
    title: '国产悬疑剧天花板推荐',
    desc: '精选近年来评分最高的国产悬疑剧集，烧脑剧情层层反转，追剧停不下来。',
    meta: '8部推荐 · 高分神作',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20anime%20inspired%20artistic%20scene%20with%20flowing%20dynamic%20lines%20and%20vibrant%20warm%20color%20palette%2C%20golden%20and%20coral%20tones%2C%20modern%20minimalist%20illustration%20style%2C%20dreamy%20atmosphere%2C%20no%20text%20no%20characters&width=800&height=500&seq=card-anime-03&orientation=landscape',
    tag: '动漫专题',
    title: '2026夏季新番追番指南',
    desc: '本季新番亮点全收录，从热血战斗到治愈日常，满足不同类型的动漫爱好者。',
    meta: '15部新番 · 每周更新',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20entertainment%20show%20atmosphere%20with%20colorful%20warm%20stage%20lighting%20effects%2C%20soft%20bokeh%20background%2C%20golden%20and%20rose%20tones%2C%20energetic%20yet%20elegant%20composition%2C%20minimalist%20abstract%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-variety-04&orientation=landscape',
    tag: '综艺看点',
    title: '周末宅家必刷综艺清单',
    desc: '轻松解压的综艺节目推荐，从音乐竞演到旅行真人秀，承包你的周末快乐时光。',
    meta: '10档节目 · 欢乐不停',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20cinematic%20atmosphere%20with%20vintage%20film%20texture%20and%20warm%20sepia%20tones%2C%20classic%20movie%20aesthetic%20with%20soft%20grain%2C%20elegant%20abstract%20composition%2C%20golden%20hour%20feeling%2C%20minimalist%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-classic-05&orientation=landscape',
    tag: '经典重温',
    title: '豆瓣9分以上华语经典',
    desc: '历久弥新的华语影史佳作，无论看多少遍都不会厌倦的永恒经典。',
    meta: '20部珍藏 · 口碑保证',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20inspired%20abstract%20scene%20with%20bold%20contrasting%20light%20and%20shadow%2C%20warm%20amber%20and%20deep%20coral%20color%20palette%2C%20dramatic%20composition%2C%20modern%20cinematic%20style%2C%20no%20text%20no%20people&width=800&height=500&seq=card-action-06&orientation=landscape',
    tag: '动作爽片',
    title: '肾上腺素飙升的动作大片',
    desc: '精选全球高燃动作电影，劲爆场面接连不断，让你一次看过瘾。',
    meta: '15部精选 · 爽到停不下来',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20movie%20atmosphere%20with%20soft%20golden%20lighting%20and%20cozy%20feeling%2C%20heartwarming%20abstract%20composition%2C%20amber%20and%20cream%20tones%2C%20gentle%20cinematic%20style%2C%20minimalist%20design%2C%20no%20text%20no%20people&width=800&height=500&seq=card-family-07&orientation=landscape',
    tag: '合家欢',
    title: '适合全家一起看的温馨电影',
    desc: '老少皆宜的优质合家欢电影，周末陪伴家人的最佳选择，温馨又治愈。',
    meta: '12部推荐 · 全家共享',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          编辑团队每日精选，为你发现好内容
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors group cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'}`}>
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-700 whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{card.desc}</p>
                <span className="text-xs text-foreground-400">{card.meta}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}